const primary = '#b6aca7';

export default {
  primary,
}
